import { mutationTypes } from '@/core/constants'

export default {
	[mutationTypes.ITEM_ATA.ADITAMENTO.ADITAR.RESET_PERCENTUAL](state) {
		state.idAta = null
		state.idsItensAta = []
		state.percentual = null
	},
}
